export const REQUEST_A_SELFSIGNUP_LINK = 'selfSignUp/requestASelfSignupLink';
export const REQUEST_A_SELFSIGNUP_LINK_START = 'selfSignUp/requestASelfSignupLinkStart';
export const REQUEST_A_SELFSIGNUP_LINK_COMPLETE =
  'selfSignUp/requestASelfSignupLinkCompleted';
export const REQUEST_A_SELFSIGNUP_LINK_ERROR = 'selfSignUp/requestASelfSignupLinkError';

export const RESEND_EMAIL_OTP = 'selfSignUp/resendEmailOtp';
export const RESEND_EMAIL_OTP_START = 'selfSignUp/resendEmailOtpStart';
export const RESEND_EMAIL_OTP_COMPLETE =
  'selfSignUp/resendEmailOtpCompleted';
export const RESEND_EMAIL_OTP_ERROR = 'selfSignUp/resendEmailOtpError';

export const VERIFY_SIGNUP_EMAIL_OTP = 'selfSignUp/verifySignupEmailOtp';
export const VERIFY_SIGNUP_EMAIL_OTP_START = 'selfSignUp/verifySignupEmailOtpStart';
export const VERIFY_SIGNUP_EMAIL_OTP_COMPLETE = 'selfSignUp/verifySignupEmailOtpCompleted';
export const VERIFY_SIGNUP_EMAIL_OTP_ERROR = 'selfSignUp/verifySignupEmailOtpError';

export const SET_SELF_SIGNUP_PASSWORD = 'selfSignUp/setSelfSignPassword';
export const SET_SELF_SIGNUP_PASSWORD_START = 'selfSignUp/setSelfSignPasswordStart';
export const SET_SELF_SIGNUP_PASSWORD_COMPLETE =
  'selfSignUp/setSelfSignPasswordCompleted';
export const SET_SELF_SIGNUP_PASSWORD_ERROR = 'selfSignUp/setSelfSignPasswordError';

export const CREATE_SELFSIGNUP_ACCOUNT = 'selfSignUp/createSelfSignupAccount';
export const CREATE_SELFSIGNUP_ACCOUNT_START = 'selfSignUp/createSelfSignupAccountStart';
export const CREATE_SELFSIGNUP_ACCOUNT_COMPLETE =
  'selfSignUp/createSelfSignupAccountCompleted';
export const CREATE_SELFSIGNUP_ACCOUNT_ERROR = 'selfSignUp/createSelfSignupAccountError';

export const CLEAR_SELF_SIGNUP_ERROR = 'signup/clearSelfSignUpErrors';

export const clearSelfSignUpErrors = (payload = {}) => ({
  type: CLEAR_SELF_SIGNUP_ERROR,
  payload,
});

export const requestASelfSignupLink = (payload = {}) => ({
  type: REQUEST_A_SELFSIGNUP_LINK,
  payload,
});

export const resendEmailOtp = (payload = {}) => ({
  type: RESEND_EMAIL_OTP,
  payload,
});

export const verifySignupEmailOtp = (payload = {}) => ({
  type: VERIFY_SIGNUP_EMAIL_OTP,
  payload,
});

export const setSelfSignPassword = (payload = {}) => ({
  type: SET_SELF_SIGNUP_PASSWORD,
  payload,
});

export const createSelfSignupAccount = (payload = {}) => ({
  type: CREATE_SELFSIGNUP_ACCOUNT,
  payload,
});
